<div class="-my-2 md:-mx-6 lg:-mx-8">
  <div class="py-8 align-middle inline-block min-w-full md:px-6 lg:px-8">
    <div class="shadow">
      <table class="w-full divide-y divide-separator table-fixed">
        <thead>
          <tr>
            <th
              class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
            >
              Datum
            </th>
            <th
              class="md:hidden px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider w-full"
            ></th>
            @if (columns.includes('project')) {
              <th
                class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
              >
                Projekt
              </th>
            }
            @if (columns.includes('position')) {
              <th
                class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
              >
                Position
              </th>
            }
            @if (columns.includes('user')) {
              <th
                class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
              >
                Mitarbeiter
              </th>
            }
            <th
              class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
            >
              Beschreibung
            </th>
            <th
              class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-right text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider w-20"
            >
              Stunden
            </th>
            <th colspan="2" class="hidden md:table-cell bg-surface-secondary w-44"></th>
            <th colspan="2" class="md:hidden bg-surface-secondary w-20"></th>
          </tr>
        </thead>
        <tfoot class="sticky bottom-0 z-10 border-t border-separator">
          <tr>
            <th
              class="px-6 py-3 bg-surface-secondary text-left text-sm leading-4 font-bold text-fg-primary uppercase tracking-wider"
            >
              Total
            </th>
            @if (columns.includes('project')) {
              <th
                class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
              ></th>
            }
            @if (columns.includes('position')) {
              <th
                class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
              ></th>
            }
            @if (columns.includes('user')) {
              <th
                class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
              ></th>
            }
            <th
              class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
            ></th>
            <th
              class="hidden md:table-cell px-6 py-3 bg-surface-secondary text-right text-sm leading-4 font-bold text-fg-primary uppercase tracking-wider"
            >
              {{ sum | formatWork }}
            </th>
            <th
              class="hidden md:px-3 md:py-3 bg-surface-secondary text-left text-xs leading-4 font-medium text-fg-secondary uppercase tracking-wider"
            ></th>
            <th
              class="px-6 md:py-3 bg-surface-secondary text-right text-sm leading-4 font-bold text-fg-primary uppercase tracking-wider"
            >
              <span class="md:hidden">{{ sum | formatWork }}</span>
            </th>
            <th class="bg-surface-secondary"></th>
          </tr>
        </tfoot>
        <tbody class="bg-surface divide-y divide-separator align-top">
          @for (work of works; track work.id) {
            <tr>
              <td
                class="hidden md:table-cell px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-fg-primary"
              >
                {{ work.data.date | date }}
              </td>
              <td class="md:hidden px-6 py-3 w-full align-top">
                <ul class="space-y-1.5 text-sm">
                  <li class="text-fg-primary text-base font-semibold flex items-center gap-2">
                    {{ work.data.date | date }}
                    @if (work.data.invoice) {
                      <span
                        class="inline-flex items-center rounded-md bg-green-100 px-2 py-0.5 text-[10px] font-medium text-green-700"
                        >Verrechnet #{{ work.data.invoice.invoiceNumber }}</span
                      >
                    }
                  </li>
                  @if (columns.includes('project')) {
                    <li class="text-fg-primary font-medium leading-tight truncate">
                      {{ work.data.project.displayName }}
                      @if (columns.includes('position')) {
                        <span class="text-fg-secondary leading-tight truncate">
                          {{ work.data.position.displayName }}
                        </span>
                      }
                    </li>
                  }

                  <li class="text-fg-subtle text-[13px] leading-snug line-clamp-2">
                    {{ work.data.description }}
                  </li>
                  <li class="flex items-center gap-1.5 text-fg-muted mt-1">
                    <app-ng-icon name="heroUserMini"></app-ng-icon>
                    <span class="truncate">{{ work.data.orgaUser.displayName }}</span>
                  </li>
                </ul>
              </td>
              @if (columns.includes('project')) {
                <td
                  class="hidden md:table-cell px-6 py-4 whitespace-nowrap text-sm leading-5 text-fg-secondary truncate"
                >
                  {{ work.data.project.displayName }}
                </td>
              }
              <td
                class="hidden md:table-cell px-6 py-4 whitespace-nowrap text-sm leading-5 text-fg-secondary truncate"
              >
                {{ work.data.position.displayName }}
              </td>
              @if (columns.includes('user')) {
                <td
                  class="hidden md:table-cell px-6 py-4 whitespace-nowrap text-sm leading-5 text-fg-secondary truncate"
                >
                  {{ work.data.orgaUser.displayName }}
                </td>
              }
              <td
                class="hidden md:table-cell px-6 py-4 text-sm leading-5 text-fg-secondary truncate break-all"
              >
                {{ work.data.description }}
              </td>
              <td
                class="table-cell w-14 md:w-16 px-3 md:px-6 py-4 whitespace-nowrap text-sm text-right leading-5 text-fg-secondary align-middle md:align-top"
              >
                {{ work.data.workMinutes | formatWork }}
              </td>
              <td
                class="hidden md:table-cell px-6 py-3 whitespace-nowrap text-sm text-center leading-5 text-fg-secondary"
              >
                @if (work.data.invoice) {
                  <span
                    class="inline-flex items-center rounded-md bg-green-100 px-2 py-1 text-xs font-medium text-green-700"
                    >Verrechnet #{{ work.data.invoice.invoiceNumber }}</span
                  >
                }
              </td>
              <td class="align-middle w-8 md:w-10 pr-2 md:px-6">
                <app-dropdown-minimal-menu class="justify-end">
                  <app-dropdown-button>
                    <app-ng-icon
                      name="heroEllipsisVerticalSolid"
                      class="text-2xl md:text-3xl"
                      strokeWidth="3"
                    ></app-ng-icon>
                  </app-dropdown-button>
                  <app-dropdown-item (menuClick)="modifyWork.emit(work)">
                    Bearbeiten
                  </app-dropdown-item>
                  @if (!work.data.invoice) {
                    <app-dropdown-item (menuClick)="deleteWork.emit(work)">
                      Löschen</app-dropdown-item
                    >
                  }
                </app-dropdown-minimal-menu>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
